<template>
    <v-container class="overflow-auto pa-5 ma-0" style="max-width: 900px">
        <v-form ref="form" @input="$emit('input', $event)">
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
            >
                <!-- username -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('username')">
                        <v-text-field
                            hide-details="auto"
                            :value="record?.username"
                            counter="100"
                            :rules="[getRule('required'), getRule('maxLength')(100)]"
                            dense
                            outlined
                            @input="onInput('username', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- initials -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('initials')">
                        <v-text-field
                            hide-details="auto"
                            :value="record?.initials"
                            counter="10"
                            :rules="[getRule('maxLength')(10)]"
                            dense
                            outlined
                            @input="onInput('initials', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- lastname -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('name')">
                        <v-text-field
                            readonly
                            hide-details="auto"
                            :value="record?.con_lastname || record?.lastname"
                            counter="100"
                            :rules="[getRule('required'), getRule('maxLength')(100)]"
                            dense
                            outlined
                            @input="onInput('lastname', $event)"
                        />
                    </LabelField>
                </v-col>
                <!-- firstname -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('vorname')">
                        <v-text-field
                            readonly
                            hide-details="auto"
                            :value="record?.con_firstname || record?.firstname"
                            counter="100"
                            :rules="[getRule('required'), getRule('maxLength')(100)]"
                            dense
                            outlined
                            @input="onInput('firstname', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
                class="mt-0"
            >
                <!-- organizer_group_id / organizer_group -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('organizer_group')">
                        <OrganizerGroupSelectField
                            :value="record?.organizer_group_id"
                            :display-value="record?.organizer_group"
                            :collection="organizerGroupCollection"
                            :disabled="!userIsAdmin()"
                            @selected="onOrganizerGroupSelect($event)"
                        />
                    </LabelField>
                </v-col>
                <!-- infomail_tgk -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('infomails_erhalten')">
                        <v-checkbox
                            class="mt-0 pt-0"
                            :input-value="record?.infomail_tgk"
                            hide-details="auto"
                            @change="onInput('infomail_tgk', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
            <v-row
                v-bind="{
                    dense: !$vuetify.breakpoint.mdAndDown,
                    noGutters: $vuetify.breakpoint.mdAndDown,
                }"
            >
                <!-- created -->
                <v-col cols="12" lg="6" :class="{ 'py-1': $vuetify.breakpoint.mdAndDown }">
                    <LabelField :label="$t('created')">
                        {{ record?.created?.formatIf('dd, DD.MM.YYYY') }}
                    </LabelField>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import { RequestedUser } from '@/models/RequestedUser';
import getRulesMixin from '@/mixins/get-form-rules';
import { OrganizerGroupCollection } from '@/models/OrganizerGroup';
import { userIsAdmin } from '@/helpers/auth';
import OrganizerGroupSelectField from '@/components/organizer_group/SelectField.vue';

export default {
    name: 'RequestedUserUserData',
    components: {
        OrganizerGroupSelectField,
    },
    mixins: [getRulesMixin],

    props: {
        record: {
            type: RequestedUser,
            required: true,
        },
    },

    data() {
        return {
            organizerGroupCollection: new OrganizerGroupCollection(),
        };
    },

    mounted() {
        this.validateForm();
    },

    methods: {
        userIsAdmin,

        validateForm() {
            this.$refs.form.validate();
        },

        onInput(field, value) {
            this.record.set(field, value);
        },

        onOrganizerGroupSelect(rec) {
            // Nach der Record selektiert wurde setzen wir sowohl den Display-Wert (damit man gleich sieht
            // was gewählt wurde), sowie die ID des Records auf dem User:
            if (rec) {
                this.record?.set('organizer_group_id', rec.id);
                this.record?.set('organizer_group', rec.title);
            } else {
                this.record?.set('organizer_group_id', null);
                this.record?.set('organizer_group', null);
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
